import ABWorkReportingService from './abWorkReporting.service';
import {
  GET_AB_WORK_REPORTING_MAPPING,
  GET_AB_WORK_REPORTING_ENTRIES,
  CREATE_AB_WORK_REPORTING_ENTRY,
  UPDATE_AB_WORK_REPORT_ENTRY,
  GET_AB_WORK_REPORTING_BATCHES,
  UPDATE_BUCKET,
  BATCH_AB_WORK_REPORTING_ENTRIES,
  ACCEPT_REJECT_AB_WORK_REPORTING_WORKSHEETS,
  GET_SAVED_AB_WORK_REPORT_FILTERS,
  CREATE_SAVED_AB_WORK_REPORT_FILTER,
  UPDATE_SAVED_AB_WORK_REPORT_FILTER,
  DELETE_SAVED_AB_WORK_REPORT_FILTER,
  SET_FAVORITE_AB_WORK_REPORT_FILTER,
  GET_AB_WORK_REPORTING_DISPLAY_FIELDS,
  SAVE_AB_WORK_REPORTING_DISPLAY_FIELDS,
  GET_AB_WORK_REPORTING_JOB_CODES,
  CREATE_AB_WORK_REPORTING_JOB_CODE,
  UPDATE_AB_WORK_REPORTING_JOB_CODE,
  DELETE_AB_WORK_REPORTING_JOB_CODE,
} from '../../state/actionTypes';

export const findRevisionDifference = (payload) => async () => {
  const { data } = await ABWorkReportingService.findRevisionDifference(payload);
  return data;
};

export const importABWorkReporting = (payload) => async () => {
  const { data } = await ABWorkReportingService.import(payload);
  return data;
};

export const getABWorkReportingMapping = () => async (dispatch) => {
  const { data } = await ABWorkReportingService.getMapping();
  dispatch({
    type: GET_AB_WORK_REPORTING_MAPPING,
    payload: data,
  });
};

export const saveABWorkReportingMapping = (payload) => async (dispatch) => {
  const { data } = await ABWorkReportingService.saveMapping(payload);
  if (!data) return false;
  dispatch({
    type: GET_AB_WORK_REPORTING_MAPPING,
    payload: data,
  });
  return true;
};

export const getWorkReportEntries = (cardId) => async (dispatch) => {
  const { data } = await ABWorkReportingService.getWorkReportEntries(cardId);
  if (!data) return false;
  dispatch({
    type: GET_AB_WORK_REPORTING_ENTRIES,
    payload: data,
  });
  return true;
};

export const createWorkReportEntries = (entries) => async (dispatch) => {
  const { data } = await ABWorkReportingService.createWorkReportEntries(entries);
  if (!data) return false;
  dispatch({
    type: CREATE_AB_WORK_REPORTING_ENTRY,
    payload: data,
  });

  dispatch({
    type: UPDATE_BUCKET,
    payload: {
      update: entries.reduce((acc, entry) => {
        acc[entry.bidItemId] = {
          statusId: entry.statusId,
        };
        return acc;
      }, {}),
    },
  });
  return true;
};

export const getWorkReportEntryBatches = () => async (dispatch) => {
  const { data } = await ABWorkReportingService.getWorkReportEntryBatches();
  if (!data) return false;
  dispatch({
    type: GET_AB_WORK_REPORTING_BATCHES,
    payload: data,
  });
  return true;
};

export const batchWorkReportEntries = (payload) => async (dispatch) => {
  const { data } = await ABWorkReportingService.batchWorkReportEntries(payload);
  if (!data) return false;
  dispatch({
    type: BATCH_AB_WORK_REPORTING_ENTRIES,
    payload: data,
  });
  return true;
};

export const updateWorkReportEntry = (id, payload, bidItemId) => async (dispatch) => {
  const { data } = await ABWorkReportingService.updateWorkReportEntry(id, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_AB_WORK_REPORT_ENTRY,
    payload: { id, ...payload },
  });
  if (payload.statusId !== undefined && bidItemId) {
    dispatch({
      type: UPDATE_BUCKET,
      payload: { update: { [bidItemId]: { statusId: payload.statusId } } },
    });
  }
  return true;
};

export const acceptRejectWorksheets = (payload) => async (dispatch) => {
  const { data } = await ABWorkReportingService.acceptRejectWorksheets(payload);
  if (!data) return false;
  dispatch({
    type: ACCEPT_REJECT_AB_WORK_REPORTING_WORKSHEETS,
    payload: data,
  });
  return data;
};

export const getSavedABWorkReportFilters = () => async (dispatch) => {
  const { data } = await ABWorkReportingService.getSavedABWorkReportFilters();
  if (!data) return false;
  dispatch({
    type: GET_SAVED_AB_WORK_REPORT_FILTERS,
    payload: data,
  });
  return true;
};

export const createSavedABWorkReportFilter = (payload) => async (dispatch) => {
  const { data } = await ABWorkReportingService.createSavedABWorkReportFilter(payload);
  if (!data) return false;
  dispatch({
    type: CREATE_SAVED_AB_WORK_REPORT_FILTER,
    payload: data,
  });
  return true;
};

export const updateSavedABWorkReportFilter = (id, payload) => async (dispatch) => {
  const { data } = await ABWorkReportingService.updateSavedABWorkReportFilter(id, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_SAVED_AB_WORK_REPORT_FILTER,
    payload: {
      id,
      ...payload,
    },
  });
  return true;
};

export const deleteSavedABWorkReportFilter = (id) => async (dispatch) => {
  const { data } = await ABWorkReportingService.deleteSavedABWorkReportFilter(id);
  if (!data) return false;
  dispatch({
    type: DELETE_SAVED_AB_WORK_REPORT_FILTER,
    payload: { id },
  });
  return true;
};

export const setFavoriteABWorkReportFilter = (id, isFavorite) => async (dispatch) => {
  const { data } = await ABWorkReportingService.setFavoriteABWorkReportFilter(id, isFavorite);
  if (!data) return false;
  dispatch({
    type: SET_FAVORITE_AB_WORK_REPORT_FILTER,
    payload: { id, isFavorite },
  });
  return true;
};

export const getABWorkReportingDisplayFields = () => async (dispatch) => {
  const { data } = await ABWorkReportingService.getDisplayFields();
  dispatch({
    type: GET_AB_WORK_REPORTING_DISPLAY_FIELDS,
    payload: data || {},
  });
};

export const saveABWorkReportingDisplayFields = (payload) => async (dispatch) => {
  const { data } = await ABWorkReportingService.saveDisplayFields(payload);
  if (!data) return false;
  dispatch({
    type: SAVE_AB_WORK_REPORTING_DISPLAY_FIELDS,
    payload: data,
  });
  return true;
};

export const getABWorkReportingJobCodes = () => async (dispatch) => {
  const { data } = await ABWorkReportingService.getJobCodes();
  if (!data) return false;
  dispatch({
    type: GET_AB_WORK_REPORTING_JOB_CODES,
    payload: data,
  });
  return true;
};

export const createABWorkReportingJobCode = (payload) => async (dispatch) => {
  const { data } = await ABWorkReportingService.createJobCode(payload);
  if (!data) return false;
  dispatch({
    type: CREATE_AB_WORK_REPORTING_JOB_CODE,
    payload: data,
  });
  return true;
};

export const updateABWorkReportingJobCode = (name, payload) => async (dispatch) => {
  const { data } = await ABWorkReportingService.updateJobCode(name, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_AB_WORK_REPORTING_JOB_CODE,
    payload: {
      name,
      payload,
    },
  });
  return true;
};

export const deleteABWorkReportingJobCode = (name) => async (dispatch) => {
  const { data } = await ABWorkReportingService.deleteJobCode(name);
  if (!data) return false;
  dispatch({
    type: DELETE_AB_WORK_REPORTING_JOB_CODE,
    payload: { name },
  });
  return true;
};